<template>
  <div :data-level="labels.length">
    <ul class="flex scale-wrap">
      <li class="inline-block relative label-wrap" v-for="(item, index) in normalLabels" :key="index">
        <div
          class="scale-item"
          :style="styleHandler(selectValue, index)"
          :class="{ selected: selectValue === item.id }"
          @click="$emit('click', item)"
        >
          <span v-if="showValue" class="text-small whitespace-nowrap">{{ item.num }}</span>
        </div>
        <span v-if="showDesc" class="label-text" v-html="item.text"></span>
      </li>
      <li class="inline-block relative label-wrap" v-for="(item,index) in unknownList">
        <div
            class="scale-item"
            style="background:transparent;"
        >
          <slot name="unknown"></slot>
        </div>
        <span class="label-text" :class="{'whitespace-nowrap':item.text.length <4}" v-html="item.text"></span>
      </li>
    </ul>
    <!--    <template v-if="!isCustom">-->
    <!--      <div class="clearfix mt-1 text-small text-theme-black-450">-->
    <!--        <div class="float-left w-1/2 box-border pr-2">-->
    <!--          <div>-->
    <!--            <span>{{ startLabel.text }}</span>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div class="float-left w-1/2 box-border pl-2">-->
    <!--          <div>-->
    <!--            <span>{{ endLabel.text }}</span>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </template>-->
  </div>
</template>

<script>
export default {
  name: 'ScaleItem',
  props: {
    labels: {
      type: Array,
      default: () => []
    },
    isCustom: {
      type: Boolean,
      default: false
    },
    showDesc: {
      type: Boolean,
      default: true
    },
    showValue: {
      type: Boolean,
      default: true
    },
    selectValue: {
      type: null
    },
    styleHandler: {
      type: Function,
      default: () => ({})
    }
  },
  computed: {
    unknownList(){
      return this.labels.filter(item=>item.num === "unknown")
    },
    normalLabels(){
      return this.labels.filter(item=>item.num !== "unknown")
    },
    startLabel() {
      return this.normalLabels[0]
    },
    endLabel() {
      return this.normalLabels[this.normalLabels.length - 1]
    }
  }
}
</script>
